import React, { useCallback, useEffect, useState } from 'react';
import { Collapse } from 'react-bootstrap';
import './Styles.scss';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
interface CollapsibleContainerProps {
  title: string;
  children?: JSX.Element;
  mainContainerClass?: string;
  collapsibleContainerClass?: string;
  disableCollapse?: boolean;
}

export default function CollapsibleContainer(props: CollapsibleContainerProps) {
  const {
    title,
    children,
    mainContainerClass = '',
    collapsibleContainerClass = '',
    disableCollapse = false,
  } = props;
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  const handleCollapse = useCallback(() => {
    setIsCollapsed((prvState) => !prvState);
  }, []);

  useEffect(() => {
    if (disableCollapse) {
      setIsCollapsed(false);
    }
  }, [disableCollapse]);

  return (
    <div
      id="collapsiblecontainer-wrapper"
      data-testid="collapsiblecontainer-wrapper"
      className={mainContainerClass}
    >
      <div
        id="collapsiblecontainer-header"
        data-testid="collapsiblecontainer-header"
        className={disableCollapse ? 'header-container-disabled' : 'header-container'}
      >
        <div
          id="collapsiblecontainer-title-container"
          data-testid="collapsiblecontainer-title-container"
          className="collapsible-container-title-container"
          onClick={handleCollapse}
        >
          <div
            id="collapsiblecontainer-header-icon"
            data-testid="collapsiblecontainer-header-icon"
            className={isCollapsed ? 'header-icon-collapsed' : 'header-icon-expanded'}
          >
            <RMSvgIcon
              id="collapsiblecontainer-svg-arrowdowm-icon"
              data-testid="collapsiblecontainer-svg-arrowdowm-icon"
              name="ArrowDown"
              width={'18px'}
              height={'18px'}
              fill="#474747"
            ></RMSvgIcon>
          </div>
          <div
            id={`collapsiblecontainer-${title}`}
            data-testid={`collapsiblecontainer-${title}`}
            className="header-title"
          >
            {title}
          </div>
        </div>

        <div
          id={`collapsiblecontainer-${title}-line`}
          data-testid={`collapsiblecontainer-${title}-line`}
          className="header-line"
          style={{ backgroundColor: '#ccc' }}
        />
      </div>
      <Collapse in={!isCollapsed}>
        <div
          id="collapsible-content"
          data-testid="collapsible-content"
          className={`group-visible w-100 ${collapsibleContainerClass}`}
        >
          {children}
        </div>
      </Collapse>
    </div>
  );
}
